import React, { useState, useEffect } from "react";
import { useNavigate , useSearchParams} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./login.css"; // Create this file for custom styles

import farmTech from "../assets/farm-tech.gif"; 
import { useLoading } from "../components/LoadingProvider"; 

import { sendOtp , verifyOtp } from "../services/auth/authService";
import LocalManager from "../Infra/LocalManager";

import UserToken from "../Infra/GetUserToken";

const Login = ({clearSession  = false}) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");


    const [allowResend, setAllowResend] = useState(false);


    const [userToken, setUserTokenp] = useState(UserToken());



      const returnUrl = searchParams.get('return'); // مثلا "/reminders/add/123"


    useEffect(()=>{


        if(clearSession === true)
        {
            
            LocalManager.removeItem('session') // clear user api token
            setUserTokenp(null)
            toast.success("خارج شدید!")

        }


        if(clearSession === false && userToken != null)
        {
        
            navigate(returnUrl || '/?alreadyLoggedIn'); 

        }

    },[userToken])




    const { toast } = useLoading()

    const navigate = useNavigate();

    const handleMobileSubmit = (e) => {
        e.preventDefault();
        // TODO: Trigger OTP send API here
        sendOtpApi();
        setStep(2);
    };

    const handleOtpSubmit = (e) => {
        e.preventDefault();
        // TODO: Verify OTP API here
        verifyOtpApi()
       // alert(t("login.success"));

    };


    const sendOtpApi = async ()=>{

            try {
                
                setAllowResend(false);

                const response = await sendOtp(mobile);
                console.log('Sent successful:', response);

                toast.success("code is sent")

                setTimeout(() => {
                    setAllowResend(true);
                }, 30 * 1000);

            } catch (error) {
               console.error('Sent failed:', error);
            }
    };


    const verifyOtpApi = async ()=>{

            try {
                const response = await verifyOtp(mobile,otp);
                console.log('Verification successful:', response);


                const token = response.token;
                const loginDte = response.at;//unix format
                const phone = response.user.phone;
                const plantsCount = response.my.plantsCount;

                
                LocalManager.setItem('session',token) // user api token
                LocalManager.setItem('LL',loginDte) // last login


                if(plantsCount == 0){
                    toast.success("Welcome! choose a plant to set reminder and enjoy...")
                    // navigate('/plants')
                    setTimeout(() => {
                            navigate(returnUrl || '/plants'); 
                    }, 500);

                }
                else{

                toast.success("Logged in successfully")

                    setTimeout(() => {
                              navigate(returnUrl || '/'); 
                    }, 500);

                }


            } catch (error) {
                if(error.status == 401)
                {
                     toast.error("code is invalid!")

                }

                console.error('Verification failed:', error);
            }
    };


    return (
        <div className="login-container">
            <div className="login-card">
                <h2>{t("login.title")}</h2>

                <div>
                    <img src={farmTech} alt="tech" width={72}/>
                </div>


                {step === 1 && (
                    <form onSubmit={handleMobileSubmit}>
                        <label htmlFor="mobile">{t("login.mobileLabel")}</label>
                        <input
                            id="mobile"
                            type="tel"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            placeholder={t("login.mobilePlaceholder")}
                            required
                            pattern="[0-9]{10,15}"
                        />
                        <button type="submit" className="login-btn">
                            {t("login.getOtp")}
                        </button>
                           <div className="mt-3">
                            <a href="/">
                                {t("login.backToHome")}
                            </a>
                        </div>
                    </form>
                )}
                {step === 2 && (
                    <form onSubmit={handleOtpSubmit}>
                        <label htmlFor="otp">{t("login.otpLabel")}</label>
                        <input
                            id="otp"
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder={t("login.otpPlaceholder")}
                            required
                            pattern="[0-9]{4,8}"
                        />
                        <button type="submit" className="login-btn">
                            {t("login.verifyOtp")}
                        </button>

                        <div className="mt-3" >
                            {allowResend &&  <a href="#" onClick={() => setStep(1)}  >
                                {t("login.resendOtp")}
                            </a>}
                            
                        </div>

                    </form>
                )}
            </div>
        </div>
    );
};

export default Login;